/* Clip wall: one clip plays at a time, the saffron bar tracks real playback. */
function initWall(wall) {
  if (wall._laReady) return;
  wall._laReady = true;
  const reels = Array.from(wall.querySelectorAll('.la-reel--video'));
  const stop = (r) => {
    const v = r.querySelector('video');
    const b = r.querySelector('.la-reel__play');
    if (v) v.pause();
    r.classList.remove('is-playing');
    if (b) b.setAttribute('aria-pressed', 'false');
  };
  reels.forEach((r) => {
    const v = r.querySelector('video');
    const b = r.querySelector('.la-reel__play');
    const bar = r.querySelector('.la-reel__bar i');
    if (!v || !b) return;
    v.muted = true;
    v.removeAttribute('controls');
    v.addEventListener('timeupdate', () => {
      if (bar && v.duration) bar.style.setProperty('--p', (v.currentTime / v.duration).toFixed(3));
    });
    v.addEventListener('ended', () => stop(r));
    b.addEventListener('click', () => {
      const playing = r.classList.contains('is-playing');
      reels.forEach((x) => { if (x !== r) stop(x); });
      if (playing) { stop(r); return; }
      r.classList.add('is-playing');
      b.setAttribute('aria-pressed', 'true');
      const p = v.play();
      if (p && p.catch) p.catch(() => stop(r));
    });
  });
}
const run = (scope = document) => scope.querySelectorAll('[data-la-clips]').forEach(initWall);
run();
document.addEventListener('shopify:section:load', (e) => run(e.target));
